import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/home";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "热门综艺", path: "/category/remen" },
  { name: "最新更新", path: "/category/remen" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline"
          >
            <span
              className={`font-heading text-2xl ${
                scrolled || !isHome
                  ? "text-primary-500"
                  : "text-white drop-shadow-lg"
              }`}
            >
              6789影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path + link.name}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 no-underline ${
                  location.pathname === link.path
                    ? scrolled || !isHome
                      ? "text-primary-500"
                      : "text-white font-bold"
                    : scrolled || !isHome
                      ? "text-foreground-700 hover:text-primary-500"
                      : "text-white/80 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/category/remen"
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer no-underline ${
                scrolled || !isHome
                  ? "bg-primary-500 text-white hover:bg-primary-600"
                  : "bg-white/20 text-white border border-white/30 hover:bg-white/30 backdrop-blur-sm"
              }`}
            >
              开始观看
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path + link.name}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors no-underline ${
                  location.pathname === link.path
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category/remen"
              className="block text-center px-5 py-3 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors no-underline"
            >
              开始观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}